export default __webpack_public_path__ + "static/media/AM_00800 copy.18b7c0fd.jpg";